import Vue from 'vue'
import Router from 'vue-router'
/* 首页 */
import Home from '../views/Home.vue'
/* 最新活动 */
import Latevents from '../views/Latevents.vue'
/* 产品及服务 */
import Productservices from '../views/Productservices.vue'
/* 合作方案 */
import Cooperaprog from '../views/Cooperaprog.vue'
/* 关于我们 */
import Aboutus from '../views/Aboutus.vue'
/* 新闻中心 */
import NewsCenter from '../views/NewsCenter.vue'
/* 联系我们 */
import Contactus from '../views/Contactus.vue'
Vue.use(Router)

export default new Router({
	mode:'history',
  routes: [
    {
    	path: '/',  
    	component: Home
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
     },
    {
      path: '/Latevents',
      name: 'Latevents',
      component: Latevents
    },
    {
      path: '/Productservices',
      name: 'Productservices',
	  component: Productservices
    },
    {
      path: '/Cooperaprog',
      name: 'Cooperaprog',
      component: Cooperaprog
    },
    {
      path: '/Aboutus',
      name: 'Aboutus',
      component: Aboutus
    },
	{
	  path: '/NewsCenter',
	  name: 'NewsCenter',
	  component: NewsCenter
	},
    {
      path: '/Contactus',
      name: 'Contactus',
      component: Contactus
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js